import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './i18n';
import { AppProvider } from './providers/AppProvider';

const root = ReactDOM.createRoot(document.getElementById('app') as HTMLElement);
root.render(
    <React.StrictMode>
        <AppProvider>
            <App />
        </AppProvider>
    </React.StrictMode>,
);
